import { render, staticRenderFns } from "./SdpiLayout.vue?vue&type=template&id=a586e510"
import script from "./SdpiLayout.vue?vue&type=script&lang=js"
export * from "./SdpiLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports